export const BLOCK_TYPE_DOCUMENT_LIST_SELECTION = 'documentListSelection';
